export default __webpack_public_path__ + "static/media/My_Highlights_page_empty_2_720x512.35a49e33.png";